import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-logo',
    templateUrl: './logo.component.html',
    standalone: false
})
export class LogoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
